import { Divider } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import {
  CustomTable,
  SearchTextInput,
  SectionLabel,
  StatusChip,
} from "components";
import { globalStyles } from "styles";
import { formatDate, wordCapitalize } from "utils";
import { statusCCID } from "../Components/Constant";

const ModalPreviewUploadCCID = ({
  open,
  onClose,
  dataModal,
  isLoading,
  queryParamsModal,
  handleChangeQueryParamsModal,
  pageCount,
}) => {
  const classes = globalStyles();

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Grid container columnGap={1}>
              <Grid item>
                <IconButton onClick={onClose}>
                  <ArrowBack />
                </IconButton>
              </Grid>
              <Grid item>
                <Typography fontSize={24} fontWeight={700}>
                  Detail Upload CCID
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container columnSpacing={2} rowSpacing={2}>
          <Grid item xs={6}>
            <SectionLabel title="DSP" subTitle={dataModal?.dsp_name || "-"} />
          </Grid>
          <Grid item xs={6}>
            <SectionLabel
              title="Generate No"
              subTitle={dataModal?.sequence || "-"}
            />
          </Grid>
          <Grid item xs={6}>
            <SectionLabel
              title="Date Period"
              subTitle={`${formatDate(dataModal?.start_date)} - ${formatDate(
                dataModal?.end_date
              )}`}
            />
          </Grid>
          <Grid item xs={6}>
            <SectionLabel
              title="Status"
              subTitle={
                <Box>
                  <StatusChip
                    label={
                      statusCCID?.[dataModal?.status]?.label ??
                      wordCapitalize(dataModal?.status)
                    }
                    type={statusCCID?.[dataModal?.status]?.type ?? "default"}
                  />
                  {dataModal?.status === "error" &&
                    dataModal?.error_message_summary && (
                      <Typography fontSize="10px" color="red" mt="5px">
                        {dataModal?.error_message_summary}
                      </Typography>
                    )}
                </Box>
              }
            />
          </Grid>
        </Grid>
        <Divider className={classes?.divider} />
        <SectionLabel title="List CCID Files" />
        <Box my={2}>
          <SearchTextInput
            fullWidth
            placeholder="Search"
            value={queryParamsModal?.search}
            onChange={e =>
              handleChangeQueryParamsModal(e?.target?.value, "search")
            }
          />
        </Box>
        <CustomTable
          isLoading={isLoading}
          columnTable={columnTable}
          data={dataModal?.list_ccid_files || []}
          page={queryParamsModal?.page}
          pageSize={queryParamsModal?.size}
          pageCount={pageCount}
          handleChangePage={(_, page) =>
            handleChangeQueryParamsModal(page, "page")
          }
          handleChangePageSize={e =>
            handleChangeQueryParamsModal(e?.target?.value, "size")
          }
          maxHeight={400}
          skeletonHeight={474}
        />
      </DialogContent>
    </Dialog>
  );
};

const columnTable = [
  {
    name: "no",
    title: "No",
  },
  {
    name: "all",
    title: "File Name",
    renderText: item => {
      const { file_name, status, error_message } = item;
      return (
        <Box>
          {file_name}
          {status === "error" && (
            <Typography fontSize="10px" color="red">
              {error_message}
            </Typography>
          )}
        </Box>
      );
    },
  },
  {
    name: "status",
    title: "Status",
    renderText: status => (
      <StatusChip
        label={statusCCID?.[status]?.label ?? wordCapitalize(status)}
        type={statusCCID?.[status]?.type ?? "default"}
      />
    ),
  },
];

export default ModalPreviewUploadCCID;
